import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.DearRequestCard.DearAdditionalChargeLines', {
    sectionHeaderText: 'Additional Charge Items',
    columnDescription: 'Description',
    columnReference: 'Reference',
    columnQuantity: 'QTY',
    columnPrice: 'Price',
    columnDiscount: 'Discount',
    columnTaxRule: 'Tax rule',
    columnTotal: 'Total',
});
